import request from '@/utils/request'
export async function login(data, loginType) {
  return request({
    url: `/power/auth/login/${loginType}`,
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/power/setting/user/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/power/auth/logout',
    method: 'post',
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    method: 'get',
  })
}

export function sendErpLoginCode(data) {
  return request({
    url: '/power/auth/sendCode',
    method: 'post',
    data,
  })
}
